// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FactoringFundsForm__checkboxRow___jDy8P{display:flex;gap:9px}.FactoringFundsForm__lastRow___ubCPe{display:flex;gap:9px;padding-bottom:14px}", "",{"version":3,"sources":["webpack://src/components/proTransportSubscriptions/styles/FactoringFundsForm.scss"],"names":[],"mappings":"AAAA,yCACE,YAAA,CACA,OAAA,CAGF,qCACE,YAAA,CACA,OAAA,CACA,mBAAA","sourcesContent":[".checkboxRow {\n  display: flex;\n  gap: 9px;\n}\n\n.lastRow {\n  display: flex;\n  gap: 9px;\n  padding-bottom: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxRow": "FactoringFundsForm__checkboxRow___jDy8P",
	"lastRow": "FactoringFundsForm__lastRow___ubCPe"
};
export default ___CSS_LOADER_EXPORT___;
